import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-task-message-status-icon',
    templateUrl: './task-message-status-icon.component.html',
    styleUrls: ['./task-message-status-icon.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskMessageStatusIconComponent {
  messageStatus = input<TaskMessageStatus>();
  customCssClass = input<string>();
}
